import './List.scss';

const ListItem = ({ indexed, isTitleBold, item: { index, image, title, description } }) => {
  if (indexed) {
    return (
      <>
        <div className="list-header">
          <div className="index-num">{index}</div>
          <div className={`index-title ${isTitleBold ? 'bold' : ''}`}>{title}</div>
        </div>
        <div className="list-item">
          {image && <img className="wrap-around" src={image} alt={title} />}
          <div className="content">
            <p>{description}</p>
          </div>
        </div>
      </>
    );
  }
  return (
    <div className="list-item">
      <img className="wrap-around" src={image} alt={title} />
      <div className="content">
        <h5>{title}</h5>
        <p>{description}</p>
      </div>
    </div>
  );
};

export const List = ({ items, indexed, isTitleBold, isFlex }) => {
  return (
    <div className={`list ${isFlex ? 'is-flex' : ''}`}>
      {items.map((item, index) => (
        <ListItem key={index} item={{ ...item, index: index + 1 }} indexed={indexed} isTitleBold={isTitleBold} />
      ))}
    </div>
  );
};
